module.exports = __webpack_public_path__ + "img/icon_map_5_off_111.671cc363.png";